/* DeleteSpaceModal.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138425zaO%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r22ADO%7Bpadding-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb2ADO%7Bpadding-right%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW2ADO%7Bpadding-bottom%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q2ADO%7Bpadding-left%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruhH7k%7Bbackground-color%3Avar(--ds-background-danger%2C%23ffeceb)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzAyGJ%7Bcolor%3Avar(--ds-text-danger%2C%23ae2e24)%7D");
import { useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '@atlaskit/button/default/button';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import type { Space } from '../../controllers/space-store/types';
import messages from './messages';
const styles = {
  errorContainer: "_0bjKvDKxmn _2sNsIgmnOE _3138425zaO _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXruhH7k _1UtDYzAyGJ"
};
type DeleteSpaceModalProps = {
  space: Space;
  isOpen: boolean;
  onClose: () => void;
  onDeleteConfirm: (spaceId: string) => Promise<void>;
};
export const DeleteSpaceModal = ({
  space,
  isOpen,
  onClose,
  onDeleteConfirm
}: DeleteSpaceModalProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const handleDelete = async () => {
    setIsSubmitting(true);
    try {
      await onDeleteConfirm(space.id);
      setError(undefined);
      onClose();
    } catch (e) {
      setError(formatMessage(messages.genericErrorMessage));
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleCancel = () => {
    setError(undefined);
    onClose();
  };
  return <ModalTransition>
			{isOpen && <Modal onClose={handleCancel} width="small" testId="deleteSpaceModal">
					<ModalHeader hasCloseButton>
						<ModalTitle>
							{formatMessage(messages.deleteSpaceTitle, {
            name: space.name
          })}
						</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<Stack>
							<Box>{formatMessage(messages.modalBody)}</Box>
							{!!error?.length && <Box xcss={styles.errorContainer}>{error}</Box>}
						</Stack>
					</ModalBody>
					<ModalFooter>
						<Button appearance="subtle" onClick={handleCancel}>
							{formatMessage(messages.cancelButtonLabel)}
						</Button>
						<Button isLoading={isSubmitting} appearance="danger" onClick={handleDelete}>
							{formatMessage(messages.deleteButtonLabel)}
						</Button>
					</ModalFooter>
				</Modal>}
		</ModalTransition>;
};